import { SellerRating } from '@components/SellerRating';
import { SellerRatingThumbCount } from '@components/SellerRatingThumbCount';
import { SellerRatingWithImage } from '@components/SellerRatingWithImage';
import { SellerRatingItem as TSellerRatingItem } from '@models';
import { logger } from '@utils/logger';

import s from './SellerRatingItem.sss';

type SellerRatingItemProps = {
  sellerRatingItems: TSellerRatingItem[];
};

export const SellerRatingItem: React.FC<SellerRatingItemProps> = ({
  sellerRatingItems,
}) => (
  <>
    {
      sellerRatingItems.map((item) => {
        switch (item.value?.__typename) {
          case 'PosNegValue':
            return (
              <SellerRatingThumbCount
                className={s.thumbCount}
                thumbUpCount={item.value.positive || 0}
                thumbDownCount={item.value.negative || 0}
                title={item.title}
              />
            );
          case 'TextValue':
            if (item.value.value) {
              return (
                <SellerRatingWithImage
                  className={s.startBlock}
                  title={item.title}
                  text={item.value.value}
                  imageLink={item.value?.img}
                />
              );
            }

            return null;
          case 'RatingValue':
            if (item.value.value) {
              return (
                <SellerRating
                  className={s.startBlock}
                  title={item.title}
                  averageRating={Number(item.value.value)}
                />
              );
            }

            return null;
          default:
            logger.error('No type for SellerRatingResultType');
            return null;
        }
      })
    }
  </>
);
